module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.cf4f9285.mp3";